import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BeginnerConfirm.css';

function BeginnerConfirm() {
    const navigate = useNavigate();
    const targetLanguage = localStorage.getItem('vozoly_target_language') || 'your language';

    return (
        <div className="bc-screen">

            <div className="bc-top">
                <button className="bc-back" onClick={() => navigate('/onboarding/path')}>←</button>
            </div>

            <div className="bc-content">

                <div className="bc-badge-wrap">
                    <div className="bc-badge">A1</div>
                    <div className="bc-badge-label">Starting level</div>
                </div>

                <div className="bc-heading">You're starting from scratch — that's perfect.</div>

                <div className="bc-desc">
                    Every fluent speaker started exactly where you are now. Vozoly will build your {targetLanguage} foundations step by step — vocabulary, grammar, pronunciation and real conversations with Gabi.
                </div>

                <div className="bc-cards">

                    <div className="bc-card">
                        <div className="bc-card-icon">🌱</div>
                        <div className="bc-card-info">
                            <div className="bc-card-title">Start from zero</div>
                            <div className="bc-card-desc">No prior knowledge needed — we start with the very basics</div>
                        </div>
                    </div>

                    <div className="bc-card">
                        <div className="bc-card-icon">🎯</div>
                        <div className="bc-card-info">
                            <div className="bc-card-title">Your first words today</div>
                            <div className="bc-card-desc">By the end of your first session you'll know 20+ real words</div>
                        </div>
                    </div>

                    <div className="bc-card">
                        <div className="bc-card-icon">📈</div>
                        <div className="bc-card-info">
                            <div className="bc-card-title">Progress at your pace</div>
                            <div className="bc-card-desc">Vozoly adapts to how fast you learn — no pressure</div>
                        </div>
                    </div>

                    <div className="bc-card">
                        <div className="bc-card-icon">🤖</div>
                        <div className="bc-card-info">
                            <div className="bc-card-title">Gabi speaks with you</div>
                            <div className="bc-card-desc">Your AI conversation partner from day one — always patient</div>
                        </div>
                    </div>

                </div>

                <div className="bc-note">
                    💡 You can move up levels as you progress — Vozoly tracks your journey automatically.
                </div>

            </div>

            <div className="bc-footer">
                <button
                    className="bc-confirm-btn"
                    onClick={() => navigate('/signup')}
                >
                    Let's go — create my account →
                </button>
            </div>

        </div>
    );
}

export default BeginnerConfirm;